import { useEffect, useState } from 'react';
import '../assets/css/drawer.css';
import usr from '../assets/img/ic_menu/usr.png';
import carta from '../assets/img/ic_menu/carta.png';
import copa from '../assets/img/ic_menu/copa.png';
import escoba from '../assets/img/ic_menu/logo_m.png';
import medalla from '../assets/img/medalla.png';
import medal from '../assets/img/medal.webp';


function hideDrawer(drawer, backdrop) {
    backdrop[0].classList.add('backdrop-hide');

    setTimeout(() => {
        backdrop[0].style.display = 'none';
    }, 500);
    drawer[0].style.transform = "translateX(-100%)";

}

function MenuDrawer(props) {
    useEffect(() => {
        const elements = document.querySelectorAll('.element'); // Select all elements with the specified class

        elements.forEach(function (element) {
            element.addEventListener('click', function () {
                let action = element.getAttribute("action")
 const drawer = document.getElementsByClassName("drawer");
        const backdrop = document.getElementsByClassName("backdrop");
        hideDrawer(drawer,backdrop)                ;
                window.location.replace('/#/' + action);
            });
        });



    }, []);
    return (
        <div className="Sesion">
            <div class="element-menu">

                <div class="row margin-menu element" action="Usuario">
                    <div class="col-2 menu-img">
                        <img class="menu-elements" src={usr} />
                    </div>
                    <div class="col-10 menu-text">
                        <small>Información de usuario</small>
                    </div>
                </div>

                <div class="row margin-menu element" action="Carta">
                    <div class="col-2 menu-img">
                        <img class="menu-elements" src={carta} />
                    </div>
                    <div class="col-10 menu-text">
                        <small>Carta</small>
                    </div>
                </div>

                <div class="row margin-menu element" action="Copa">
                    <div class="col-2 menu-img">
                        <img class="menu-elements" src={copa} />
                    </div>
                    <div class="col-10 menu-text">
                        <small>Copa de las casas</small>
                    </div>
                </div>

                 <div class="row margin-menu element" action="Ranking">
                    <div class="col-2 menu-img">
                        <img class="menu-elements" src={medalla} />
                    </div>
                    <div class="col-10 menu-text">
                        <small>Ranking</small>
                    </div>
                </div>

                <div class="row margin-menu element" action="Acerca">
                    <div class="col-2 menu-img">
                        <img class="menu-elements" src={escoba} />
                    </div>
                    <div class="col-10 menu-text">
                        <small>¿Quienes somos?</small>
                    </div>
                </div>

                 <div class="row margin-menu element" action="Visitados">
                    <div class="col-2 menu-img">
                        <img class="menu-elements" src={medal} />
                    </div>
                    <div class="col-10 menu-text">
                        <small>Visitados y recomendados</small>
                    </div>
                </div>

                

            </div>
        </div>);
}

export default MenuDrawer;